import CRUD from './crud'

export default new CRUD('cities', 'superior-judge')
